import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useQuery} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post, put, del } from "@utils/axios_api";
import { toast } from 'react-toastify';

const fetchPositionList = async (params) => {
  const response = await get("/user/comp/positionList", { params });
  return response;
};

export function usePositionList(compCode) {
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedItems, setSelectedItems] = useState([]);

  const methods = useForm({
    defaultValues: {
      useYn: "Y",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = parseInt(searchParams.get("pageSize") || "10", 10);

  const queryParam = {
    pageIndex,
    recordCountPerPage,
    compCode
  };

  const { data,  refetch } = useQuery({
    queryKey: ["selectPositionList", queryParam],
    queryFn: () => fetchPositionList(queryParam),
    enabled: !!compCode,  // 회사가 선택되지 않으면 조회하지 않음
    keepPreviousData: true,
    staleTime: 600000,
 });

  const onSubmit = () => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };

  const changePageSize = (size) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageSize", String(size));
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handleSelectAll = (e) => {
    if (!data || !data.resultList) return;
    const { checked } = e.target;
    if (checked) {
      const allIds = data.resultList.map((item) => item.posCode);
      setSelectedItems(allIds);
    } else {
      setSelectedItems([]);
    }
  };

  const handleSelectItem = (posCode) => {
    if (selectedItems.includes(posCode)) {
      setSelectedItems(selectedItems.filter((id) => id !== posCode));
    } else {
      setSelectedItems([...selectedItems, posCode]);
    }
  };

  const createPosition = async (formData) => {
    try {
      const requestData = {
        ...formData,
        posLevel: Number(formData.posLevel || 0),
        compCode: compCode,
      }
      await post("/user/comp/insertPosition", requestData);
      toast.success("등록 완료");
      refetch();
    } catch (err) {
      console.error(err);
    }
  };

  const updatePosition = async (formData) => {
    try {
      const requestData = {
        ...formData,
        posLevel: Number(formData.posLevel || 0),
      }
      await put("/user/comp/updatePosition", requestData);
      toast.success("수정 완료");
      refetch();
    } catch (err) {
      console.error(err);
    }
  };

  const deletePosition = async () => {
    if (selectedItems.length === 0) {
      toast.warn("삭제할 항목을 선택해주세요.");
      return;
    }
    if (!window.confirm("삭제 하시겠습니까?")) return;
    try {
      await del("/user/comp/deletePosition", { data: { posCodes: selectedItems } });
      toast.success("삭제 완료");
      refetch();
      setSelectedItems([]);
    } catch (err) {
      console.error(err);
    }
  };



  // 체크 여부
  const isAllChecked = !!(data?.resultList && data.resultList.length > 0 && selectedItems.length === data.resultList.length);

  return {
    methods, data,
    selectedItems, isAllChecked,
    onSubmit, handlePageChange, changePageSize, handleSelectAll, handleSelectItem,
    pageIndex, recordCountPerPage,
    createPosition, updatePosition, deletePosition,
  };
}
